<template>
  <section @wheel.prevent="wheelItBetter( $event, myData, myFunc )">
    <div 
      class="work-active"
      :class="{ 
        'on': start, 
        'leave': leave, 
        'recover': recover,
        'prev': come
      }">
      <div 
        id="rotation-num" 
        class="rotation-num">
        <div class="num">{{ (parseInt(workActive.index, 10) + 100).toString().substr(1) }}</div>
      </div>

      <div 
        id="rotation-title" 
        class="rotation-title"
        @click="go(workActive)">
        <div 
          class="title"
          :style="{ color: workActive.title_color }"
        >{{ workActive.title }}</div>
      </div>

      <div class="bg-box">
        <div class="bg-images" @click="go(workActive)">
          <img :src="workActive.bg_image"/>
        </div>
        <div class="blank-box" :style="{ background: workActive.bg_color }"></div>
      </div>

      <div class="category">
        {{ workActive.sub_title }}
      </div>
    </div>

    <div 
      class="work-prev"
      :class="{ 
        'prev-on' : come, 
        'recover': recover,
      }">
      <div 
        id="rotation-num" 
        class="rotation-num">
        <div class="num">{{ (parseInt(workPrev.index, 10) + 100).toString().substr(1) }}</div>
      </div>

      <div 
        id="rotation-title" 
        class="rotation-title">
        <div 
          class="title"
          :style="{ color: workPrev.title_color }"
        >{{ workPrev.title }}</div>
      </div>

      <div class="bg-box">
        <div class="bg-images">
          <img :src="workPrev.bg_image"/>
        </div>
        <div class="blank-box" :style="{ background: workPrev.bg_color }"></div>
      </div>

      <div class="category">
        {{ workPrev.sub_title }}
      </div>
    </div>

    <div 
      class="work-next"
      :class="{ 
        'on' : leave, 
        'recover': recover,
      }">
      <div 
        id="rotation-num" 
        class="rotation-num">
        <div class="num">{{ (parseInt(workNext.index, 10) + 100).toString().substr(1) }}</div>
      </div>

      <div 
        id="rotation-title" 
        class="rotation-title">
        <div 
          class="title"
          :style="{ color: workNext.title_color }"
        >{{ workNext.title }}</div>
      </div>

      <div class="bg-box">
        <div class="bg-images">
          <img :src="workNext.bg_image"/>
        </div>
        <div class="blank-box" :style="{ background: workNext.bg_color }"></div>
      </div>

      <div class="category">
        {{ workNext.sub_title }}
      </div>
    </div>

    <div class="shape" @click="goNext()">
      <div class="bt"><em></em>Next</div>
      <div class="obj"></div>
    </div>
  </section>

</template>

<script>
export default {
  name: 'Page.Main',
  data() {
    return {
      start       : false,
      leave       : false,
      recover     : false,
      prev        : false,
      come        : false,
      show        : 1,
      works       : [],
      workActive  : [],
      workNext    : [],
      workPrev    : [],
      
    }
  },
  mounted() {
    this.works = this.$root.works
    
    this.workActive = this.works[this.show - 1]
    this.workActive.index = this.show

    setTimeout(() => {
      this.start = true
    }, 500)
  },
  methods: {
    goPrev() {
      if(this.leave || this.recover || this.come) return

      this.come = true

      if(this.show != 1) {
        this.show--
      }else{
        this.show = this.works.length - 1
      }
      
      this.workPrev = this.works[this.show - 1]
      this.workPrev.index = this.show
      

      setTimeout(() => {
        this.workActive = this.works[this.show - 1]
        this.workActive.index = this.show

        if(this.show == this.works.length) this.show = 0

        this.workPrev = this.works[this.show]
        this.workPrev.index = this.show + 1

        this.recover = true
        this.come = false

        setTimeout(() => {
          this.recover = false
        }, 500)

      }, 2000)
    },
    goNext() {
      if(this.leave || this.recover || this.come) return

      this.leave = true
      this.show++
      this.workNext = this.works[this.show - 1]
      this.workNext.index = this.show
      

      setTimeout(() => {
        this.workActive = this.works[this.show - 1]
        this.workActive.index = this.show

        if(this.show == this.works.length) this.show = 0

        this.workNext = this.works[this.show]
        this.workNext.index = this.show + 1

        this.recover = true
        this.leave = false

        setTimeout(() => {
          this.recover = false
        }, 500)

      }, 2000)
    },
    go(d) {
      this.$router.push('/portfolio/project/' + d.title.toLowerCase().replace(/\s/g,'-'))
    },
    wheelItBetter ( event ) {
      if ( event.deltaY < 0 ) {
        this.goPrev()
      } else {
        this.goNext()
      }
    }
  },

}
</script>

<style scoped lang="scss">
    @import '@/assets/scss/main.scss';
</style>